import { render, staticRenderFns } from "./BattlesItemElement.vue?vue&type=template&id=b7462fb0&scoped=true"
import script from "./BattlesItemElement.vue?vue&type=script&lang=js"
export * from "./BattlesItemElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesItemElement.vue?vue&type=style&index=0&id=b7462fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7462fb0",
  null
  
)

export default component.exports